import { z } from 'zod'

export const workflowDtoSchema = z.object({
  id: z.string(),
  name: z.string(),
  description: z.string().nullable().optional(),
  status: z.string(),
  version: z.number(),
  isActive: z.boolean(),
  tenantId: z.string().optional(),
  tags: z.array(z.string()).nullable().optional(),
  definition: z.unknown().nullable().optional(),
  createdAt: z.string(),
  updatedAt: z.string().nullable().optional(),
})

export type WorkflowDto = z.infer<typeof workflowDtoSchema>

export const pagedWorkflowDataSchema = z.object({
  items: z.array(workflowDtoSchema),
  totalCount: z.number(),
  page: z.number(),
  pageSize: z.number(),
  totalPages: z.number(),
})

export const pagedWorkflowResponseSchema = z.object({
  success: z.boolean(),
  data: pagedWorkflowDataSchema,
})
